/**
 * @tabler/icons-react v2.39.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPanoramaHorizontalOff = createReactComponent(
  "panorama-horizontal-off",
  "IconPanoramaHorizontalOff",
  [
    [
      "path",
      {
        d: "M10.95 6.952c2.901 .15 5.803 -.323 8.705 -1.42a1 1 0 0 1 1.345 .934v10.534m-3.212 .806c-4.483 -1.281 -8.966 -1.074 -13.449 .622a.993 .993 0 0 1 -1.339 -.935v-11.027a1 1 0 0 1 1.338 -.935c.588 .221 1.176 .418 1.764 .59",
        key: "svg-0"
      }
    ],
    ["path", { d: "M3 3l18 18", key: "svg-1" }]
  ]
);

export { IconPanoramaHorizontalOff as default };
//# sourceMappingURL=IconPanoramaHorizontalOff.js.map
